import baseAPI from "@/api/base";
import type { AxiosResponse } from "axios";
import type {
  CreateCustomFieldDto,
  GetCustomFieldsParams,
  UpdateCustomFieldDto,
} from "@/dtos/CustomField.dto";
import {
  CREATE_CUSTOM_FIELD_URL,
  DELETE_CUSTOM_FIELD_URL,
  GET_CUSTOM_FIELDS_URL,
  UPDATE_CUSTOM_FIELD_URL,
} from "@/utils/urls";

class CustomField {
  static getCustomFields = async (params: GetCustomFieldsParams): Promise<AxiosResponse> => {
    return baseAPI.get(GET_CUSTOM_FIELDS_URL, { params });
  };

  static createCustomField = async (data: CreateCustomFieldDto): Promise<AxiosResponse> => {
    return baseAPI.post(CREATE_CUSTOM_FIELD_URL, data);
  };

  static updateCustomField = async (
    id: string,
    data: UpdateCustomFieldDto
  ): Promise<AxiosResponse> => {
    return baseAPI.patch(UPDATE_CUSTOM_FIELD_URL(id), data);
  };

  static deleteCustomField = async (id: string): Promise<AxiosResponse> => {
    return baseAPI.delete(DELETE_CUSTOM_FIELD_URL(id));
  };
}

export default CustomField;
